<div class="info-stocks-analytics">
	<app-tech-analysis
		[lang]="lang()"
		[theme]="theme()"
		[priceTarget]="priceTarget()"
		[isLoadingPriceTarget]="isLoadingPriceTarget()"
	/>
	<app-analysts-forecast
		[recommendations]="recommendations()"
		[isLoadingRecommendations]="isLoadingRecommendations()"
		[totalAnalysts]="totalAnalysts()"
		[liveTicker]="liveTicker()"
	/>
	<app-price-forecast
		[lang]="lang()"
		[theme]="theme()"
		[priceTarget]="priceTarget()"
		[isLoadingPriceTarget]="isLoadingPriceTarget()"
		[widget]="widget()"
		[recommendations]="recommendations()"
		[isLoadingRecommendations]="isLoadingRecommendations()"
		[totalAnalysts]="totalAnalysts()"
		[liveTicker]="liveTicker()"
	/>
</div>
